// extracted by mini-css-extract-plugin
export default {"table":"WordList_table__1IvxO","icon":"WordList_icon__3_Bp6","wordType":"WordList_wordType__2bGc0","transliteration":"WordList_transliteration__3Z9Nd"};